import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { UseContext } from "../context";
import { useContext } from "react";
import { notification } from "antd";
import axios from "axios";
import Loadingcom from "../searchfortravel/allcomponent/Loading";
import { Navigate } from "react-router-dom";
import { url } from "../url";
import { requestForToken } from "../firebase";
import { Capacitor } from "@capacitor/core";
import { toEnglishDigits } from "../utils/numbers";

const Recievecode = () => {
  const {
    setShownav,
    setGetprofloading,
    setGetmyprof,
  } = useContext(UseContext);
  const [loading, setloading] = useState(false);
  let navigate = useNavigate();
  const phonenumber = Cookies.get("phonenumber");
  const handleshoweditprof = () => {
    setloading(true);
    setShownav(false);
    axios
      .post(`${url}/driver/v1/submit-otp`, {
        mobile: phonenumber,
        code: Otpnum,
      })
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem("token", res.data.data.tokens.accessToken);
          getmyprofile();
          // Android permission is requested from the explicit button on /home.
          // Keep the existing web login behavior unchanged.
          requestForToken({ requestPermission: !Capacitor.isNativePlatform() });
        }
      })
      .catch((error) => {
        notification.error({
          message: "مشکلی پیش آمده است",
          description: error.response?.data?.message || "ارتباط برقرار نشد. دوباره تلاش کنید.",
        });
        setloading(false);
      });
  };

  function getmyprofile() {
    axios
      .get(`${url}/driver/v1/get-my-profile`, {
        timeout: 15000,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setGetmyprof(res.data.data);
        setGetprofloading(false);
        checkProfileStatus(res.data.data);
      })
      .catch((error) => {
        // App.js owns the global profile retry/error state after OTP login.
        setloading(false);
        notification.error({
          message: "خطا در دریافت پروفایل",
          description: error.response?.data?.message || "دوباره تلاش کنید.",
        });
      });
  }
  const checkProfileStatus = (profile) => {
    // Use the response itself rather than context state, which is updated asynchronously.
    if (profile?.status === "profile_not_completed") {
      navigate("/UserandCarinformation");
    } else if (profile) {
      navigate("/home");
    } else {
      setloading(false);
      notification.error({
        message: "خطا",
        description: "داده‌های پروفایل کاربر دریافت نشد.",
      });
    }
  };

  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleOtpChange = (index, value) => {
    const normalizedValue = toEnglishDigits(value);
    const newOtp = [...otp];
    newOtp[index] = normalizedValue;
    setOtp(newOtp);
    if (normalizedValue.length === 1 && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      const newOtp = [...otp];
      if (newOtp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
        newOtp[index - 1] = "";
      } else {
        newOtp[index] = "";
      }
      setOtp(newOtp);
    }
  };

  const Otpnum = otp.join("");

  return (
    <>
      {localStorage.getItem("token") === null ? (
        <>
          {phonenumber !== "" ? (
            <div className="h-full w-full flex flex-col justify-center relative items-center lg:flex lg:flex-col lg:justify-center lg:items-center">
              <div className="mt-10">
                <p className="text-[24px] font-normal text-black">
                  کد تایید را وارد کنید.
                </p>
              </div>
              <div className="mt-6">
                <p className="text-graytext md:text-[18px] text-[16px] font-medium">
                  کد تأیید به شمارهٔ
                  <span className="text-black"> {phonenumber} </span> ارسال شد.
                </p>
              </div>
              <div className="flex mt-6 px-2">
                <div
                  className="flex justify-center flex-row-reverse gap-2"
                  id="inputs"
                >
                  {otp.map((digit, index) => (
                    <input
                      ref={(el) => (inputRefs.current[index] = el)}
                      key={index}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => {
                        handleOtpChange(index, e.target.value);
                        setloading(false);
                      }}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      className={`outline-none text-[26px] md:w-[15%] md:h-[55px] w-[48px] h-[48px] text-center border border-gray-300 rounded-md focus:outline-none ${digit ? "input-filled" : ""
                        }`}
                      style={{ direction: "ltr" }}
                      pattern="[0-9]"
                      autoFocus={index === 0}
                    />
                  ))}
                </div>
              </div>

              <div className="flex-grow w-full relative  flex flex-col justify-end items-center px-4 md:px-0 mt-4 ">
                <button
                  className="bg-[#100E34] fixed lg:w-[30%]   w-[90%]  h-[50px] rounded-[10px] mb-[100px]  "
                  onClick={handleshoweditprof}
                >
                  {loading === false ? (
                    <p className="text-white text-[16px] font-medium">تایید</p>
                  ) : (
                    <Loadingcom />
                  )}
                </button>
              </div>
            </div>
          ) : (
            <Navigate to="/" />
          )}
        </>
      ) : (
        <Navigate to="/home" />
      )}
    </>
  );
};

export default Recievecode;
